import { useEffect } from "react";
import { doLogout, useAuthDispatch } from "../context/Auth";

const Navi = ()=>{

	const dispatch = useAuthDispatch();
	const handle_logout = ()=>{
		doLogout(dispatch);

	}


	useEffect(()=>{


	})


	return (
		<>	
			<button onClick={handle_logout}>Log Out</button>
		</>
	)
}

export default Navi;